import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

export interface Tab {
  id: string;
  text: string;
}

@Component({
  /* eslint-disable-next-line @angular-eslint/component-selector */
  selector: 'ui-kit-tabs-switch',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'tabs-switch.component.html',
})
export class TabsSwitchComponent {
  // @ts-expect-error
  @Input() tabs: Tab[];
  // @ts-expect-error
  @Input() activeTab: Tab;
  // @ts-expect-error
  @Input() dark: boolean;
  @Input() grayBack = false;
  @Input() fullWidth = false;
  @Output() tabIdChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() tabChanged: EventEmitter<Tab> = new EventEmitter<Tab>();

  handleSwitch(tab: Tab) {
    this.tabIdChanged.emit(tab.id);
    this.tabChanged.emit(tab);
  }

  constructor() {}
}
